<template>
  <div class="all_tags">
    <!-- <div class="head" v-if="isShow">
      <van-icon class="back_btn" name="arrow-left" @click="back" />
      <div class="title">
        老带新推荐
      </div>
    </div> -->
    <template v-if="tagArr.length">
      <div class="tags">
        <span
          v-for="item in tags"
          :key="item.propertyName"
          v-show="
            item.propertyName !== '备注信息' &&
              item.propertyName !== '客户最关注的方面（多选）' &&
              item.propertyValue !== ''
          "
          >{{ item.propertyValue }}</span
        >
      </div>
      <div class="import">
        <span v-for="item in tagArr" :key="item.tagArr" v-show="item">{{
          item
        }}</span>
      </div>
    </template>
    <div class="nodata" v-else>
      <no-data tip="暂无数据" />
    </div>
  </div>
</template>

<script>
import nodata from "@/components/nodata";
import { Icon } from "vant";
export default {
  data() {
    return {
      tags: "",
      tagArr: [],
      isShow: true,
    };
  },
  components: {
    "van-icon": Icon,
    "no-data": nodata,
  },
  created() {
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
    document.title = "老带新推荐";
    this.tags = this.$route.query.tagList;
    this.tags.forEach((item) => {
      if (item.propertyName === "客户最关注的方面（多选）") {
        this.tagArr = item.propertyValue.split(",");
      }
    });
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "progressDetail") {
        // vm.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":false}');
        // vm.$jsBridge.callHandler("dispatchBackBtn");
        // vm.$jsBridge.registerhandler("onBackPressed", () => {
        //   vm.back();
        // });
      } else {
        vm.isShow = false;
      }
    });
  },
  methods: {
    back() {
      // this.$router.push({
      //   name: "progressDetail",
      //   params: {
      //     id: this.$route.params.id,
      //   },
      // });
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 99px;
  padding-right: 20px;
  font-size: 36px;
  width: 100%;
  border-bottom: 1px solid #ddddddff;
  .back_btn {
    width: 100px;
    height: 99px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    padding: 10px;
  }
  .title {
    font-weight: 500;
    color: #333333;
    text-align: center;
    width: 100%;
    padding-right: 100px;
  }
}
.tags {
  padding: 20px 20px 0 20px;

  span {
    padding: 20px;
    min-width: 204px;
    min-height: 56px;
    background: #f6eadc;
    border-radius: 28px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 20px 15px;
  }
}
.import {
  padding: 0 20px 0 20px;
  span {
    padding: 20px;
    min-width: 204px;
    min-height: 56px;
    background: #d8eee7;
    border-radius: 28px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 20px 15px;
    color: #007458;
  }
}
.all_tags {
  .nodata {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
